/**
 * Ny versjon av nettflata.
 *
 * HER LAA EN STILLE BLINDVEI, og den kostet en publisering. En fane som alt
 * staar aapen kjoerer den JavaScript-en den ble lastet med — for alltid.
 * Service workeren henter ned den nye versjonen i bakgrunnen, men det hjelper
 * bare NESTE lasting. Flata saa riktig ut, knappene sto der, og handlingen
 * bak dem var gammel: en kameraplan ble publisert og ble liggende i vaar egen
 * tabell, fordi arket ikke fantes i den versjonen nettleseren faktisk kjoerte.
 *
 * Nettflata staar aapen i timer paa et sett. Da er «den oppdaterer seg til
 * neste gang» ikke godt nok — det maa staa noe paa skjermen.
 *
 * SIGNALET ER `controllerchange`, OG BARE DET.
 *
 * Foerste utgave her leste `registration.waiting` og lyttet paa
 * `updatefound`. Det er tre tilstander og to hendelser som maa falle riktig
 * i forhold til hverandre, og de gjorde det ikke: vakta ble staaende taus
 * med en ferdig nedlastet versjon i hendene. `controllerchange` er én
 * hendelse med én betydning — en ny service worker har tatt over denne
 * sida — og den fyrer nettopp naar den nye versjonen er i drift.
 *
 * Derfor er `registerType` «autoUpdate» i vite.config.ts: den genererte
 * arbeideren hopper over koen og tar over sidene av seg selv. Det er trygt,
 * for det er BARE arbeideren som byttes — sidas egen kode staar til man
 * laster om, og det gjoer man paa et trykk.
 */

const HENDELSE = "infoflyt:nyversjon";

let venter = false;

export function nyVersjonVenter(): boolean {
  return venter;
}

/** Abonnerer paa at en ny versjon melder seg. Returnerer oppsigelsen. */
export function paaNyVersjon(lytter: () => void): () => void {
  window.addEventListener(HENDELSE, lytter);
  return () => { window.removeEventListener(HENDELSE, lytter); };
}

/** Tar den nye versjonen i bruk. Arbeideren har alt tatt over; sida lastes om. */
export function taINyVersjon(): void {
  window.location.reload();
}

export function startOppdateringsvakt(): void {
  if (!("serviceWorker" in navigator)) return;

  /*
   * FOERSTE BESOEK SKAL IKKE VARSLE.
   *
   * Da er `controller` tom, og den foerste arbeideren tar over med én gang.
   * Det er ikke en ny versjon — det er den eneste versjonen. Leses her, foer
   * noe som helst rekker aa endre den.
   */
  const haddeKontroller = navigator.serviceWorker.controller !== null;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!haddeKontroller || venter) return;
    venter = true;
    window.dispatchEvent(new CustomEvent(HENDELSE));
  });

  /*
   * TAR DEN SELV NAAR DU KOMMER TILBAKE.
   *
   * Knappen alene holdt ikke. Den staar i toppstripa og maa SES, og en
   * flate som ser helt riktig ut gir ingen grunn til aa se etter den — to
   * ganger har en gammel bunt kostet tid her: en kameraplan som ble
   * publisert uten ark, og en rapport som «ikke dukket opp».
   *
   * Oeyeblikket man kommer tilbake til fana er det trygge: ingenting er
   * underveis, og det er slik enhver app paa telefonen oppfoerer seg. Men
   * bare etter et EKTE fravaer — et blikk bort og tilbake skal ikke rive
   * sida vekk — og aldri mens noen staar og skriver i et felt.
   */
  const BORTE_LENGE_MS = 60000;
  let borteSiden = 0;

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") { borteSiden = Date.now(); return; }
    if (!venter || borteSiden === 0) return;
    if (Date.now() - borteSiden < BORTE_LENGE_MS) return;

    /* Staar markoeren i et felt, er det noe halvskrevet der. Da venter vi
       paa trykket i stedet. */
    const i = document.activeElement;
    const skriver = i instanceof HTMLInputElement
      || i instanceof HTMLTextAreaElement
      || (i instanceof HTMLElement && i.isContentEditable);
    if (skriver) return;

    taINyVersjon();
  });

  void navigator.serviceWorker.register("/sw.js", { scope: "/" }).then((reg) => {
    /*
     * Ser etter ny versjon naar fana hentes fram, og hvert minutt.
     *
     * EN FANE SOM STAAR AAPEN HELE DAGEN spoer ellers aldri: nettleseren ser
     * etter en ny arbeider ved navigasjon, og her er det ingen. Et `update()`
     * er en betinget foresporsel paa noen kilobyte.
     */
    const se = (): void => {
      if (venter) return;
      void reg.update().catch(() => { /* uten nett. Da staar vi. */ });
    };
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") se();
    });
    window.setInterval(se, 60 * 1000);
  }).catch(() => {
    /* Registreringen feilet. Flata virker, bare uten offline-skall. */
  });
}
